<div mat-dialog-title class="dialog-title p-3 pr-5" *ngIf="show_title">
  <h5>{{ action?.id ? 'Edit Task' : 'Create Task' }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>

  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit()">

  <hr class="m-0 p-0" *ngIf="show_title">

  <mat-dialog-content [ngClass]="!show_title ? 'in-tabs px-3 py-4' : 'px-3 py-4'">

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Task</mat-label>
      <input
        matInput
        placeholder="Task"
        [(ngModel)]="action.name"
        name="name"
        type="text"
        required
        #name/>
      <mat-error *ngIf="!name.valid">Please enter a Task.</mat-error>
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Description</mat-label>
      <textarea
        rows="4"
        matInput
        placeholder="Description"
        [(ngModel)]="action.description"
        name="description">
      </textarea>
    </mat-form-field>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Type</mat-label>
          <mat-select
            matInput
            placeholder="type"
            [(ngModel)]="action.type"
            name="type"
            type="text"
            id="type">
            <mat-option *ngFor="let type of types" [value]="type">
              {{type}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Priority</mat-label>
          <mat-select
            matInput
            placeholder="Priority"
            [(ngModel)]="action.priority"
            name="priority"
            type="text"
            id="priority">
            <mat-option *ngFor="let priority of priorities" [value]="priority">
              {{priority}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Due Date</mat-label>
          <input
            matInput
            (dateInput)="onDateChange($event.value)"
            [matDatepicker]="picker"
            placeholder="Due Date"
            [(ngModel)]="action.due"
            name="due"
            #due
            readonly
            (click)="picker.open()"/>
          <mat-datepicker-toggle matSuffix [for]="picker"> </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field *ngIf="!isSystemOrigin" class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-select
            matInput
            placeholder="Origin"
            [(ngModel)]="action.origin"
            name="origin"
            type="text"
            id="origin">
            <mat-option *ngFor="let origin of nonSystemOrigins" [value]="origin">
              {{origin}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="form-control">
      <label>Status</label>
      <mat-slide-toggle [(ngModel)]="action.completed" name="status">
        {{ action.completed ? 'Completed' : 'Open' }}
      </mat-slide-toggle>
    </div>

    <div class="full-width pt-2" *ngIf="!action.id">
      <mat-slide-toggle [(ngModel)]="action.individual_actions" name="individual-actions">
        Create individual tasks for each selected user
      </mat-slide-toggle>
    </div>

    <p class="pt-3">
      <small>
        <b>Note:</b> Assigned users will be notified to action the tasks that are assigned to them.
      </small>
    </p>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="p-3">

    <button
      class="my-2 ml-1 mr-2"
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="submit"
      id="save">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      class="my-2 ml-1 mr-2"
      mat-raised-button
      type="button"
      (click)="onSelectSite()"
      [matBadge]="'' + (action.site_id ? 1 : 0)"
      color="secondary">
      <mat-icon>location_on</mat-icon>
      {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}
    </button>

    <button
      *ngIf="canViewNetworkedUsers"
      class="my-2 ml-1 mr-2"
      mat-raised-button
      type="button"
      (click)="selectAssignee()"
      [matBadge]="'' + (action.user_ids?.length || 0)"
      color="secondary">
      <mat-icon>account_circle</mat-icon>
      Users
    </button>

    <app-file-browse-button
      (selectedFiles)="onSelectFiles($event)"
      (afterDialogClosedEvent)="action.id ? onSubmit() : null"
      parentObjectType="action"
      [parentObjectId]="action.id"
      [filesCount]="action.files.length">
    </app-file-browse-button>

    <button
      *ngIf="action?.creator?.id === currentUserId"
      class="dialog-remove-button my-2 ml-auto mr-1"
      type="button"
      color="warn"
      mat-icon-button
      [disabled]="!action.id"
      (click)="delete()">
      <mat-icon>delete</mat-icon>
    </button>

  </mat-dialog-actions>

</form>
